/** Best-effort client IP for consent audit (replace with server header in production). */
export async function fetchClientIp(): Promise<string> {
  try {
    const res = await fetch('https://api.ipify.org?format=json', { cache: 'no-store' });
    if (!res.ok) return 'unknown';
    const data = (await res.json()) as { ip?: string };
    return data.ip ?? 'unknown';
  } catch {
    return 'unknown';
  }
}
